import { render, staticRenderFns } from "./CustomerDetailReviews.vue?vue&type=template&id=c32b0aac"
import script from "./CustomerDetailReviews.vue?vue&type=script&lang=js"
export * from "./CustomerDetailReviews.vue?vue&type=script&lang=js"
import style0 from "./CustomerDetailReviews.vue?vue&type=style&index=0&id=c32b0aac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports